export const oneD_barcodes = [
    {
        slug : "codabar",
        char_set: "numbers 0-9, dash (-} dollar ($} colon (:} slash (/} full stop (.) or plus (+)",
        length: "Variable (must begin and end with the characters A, B, C or D)",
        category: "",
        data_d_type:"1d",
        data_sym_type:"18",
        example:"A0123456789B",
        regex: "^[A-Da-d][0-9$:\/.+-]*[A-Da-d]$"
    },
    {
        slug : "code-11",
        char_set: "0-9; -",
        length: "Variable (unlimited)",
        category: "Telecommunications",
        data_d_type:"1d",
        data_sym_type:"1",
        example:"123456789",
        regex: "^[0-9-]*$"
    },
    {
        slug : "code-25",
        char_set: "0-9;",
        length: "Variable - up to a maximum of 45 digits",
        category: "",
        data_d_type:"1d",
        data_sym_type:"7",
        example:"123456789",
        regex: "^[0-9]{1,45}$",
    },
    {
        slug : "code-32",
        char_set: "0-9;",
        length: "Variable (numeric input up to 8 digits)",
        category: "Pharmacy Industry",
        data_d_type:"1d",
        data_sym_type:"129",
        example:"12345678",
        regex: "^[0-9]{1,8}$",
    },
    {
        slug : "code-39",
        char_set: "0-9, A-Z, -, +, space, *, $, /, %, .",
        length: "Variable (unlimited)",
        category: "Industrial, Government, Postal, Medical, Most popular",
        data_d_type:"1d",
        data_sym_type:"8",
        example:"1A2345678Z",
        regex: "^[0-9a-zA-Z\-\+\*\$\/%. ]+$"
    },
    {
        slug : "code-93",
        char_set: "0-9, A-Z, -, +, space, *, $, /, %, .",
        length: "Variable (unlimited)",
        category: "Postal, Tracking",
        data_d_type:"1d",
        data_sym_type:"25",
        example:"barkoder.com",
        regex: "^[0-9a-zA-Z\-\+\*\$\/%. ]+$"
    },
    {
        slug : "code-128",
        char_set: "ASCII",
        length: "Variable (unlimited)",
        category: "Transport, Shipping, Tracking, Most popular",
        data_d_type:"1d",
        data_sym_type:"20",
        example:"barkoder.com",
        regex: "^[\x00-\x7F]+$"
    },
    {
        slug : "ean-upc-code",
		char_set: "0-9",
        length: "Fixed (2,5, 7 or 12 (depending on the type))",
        category: "Retail",
        data_d_type:"1d",
        data_sym_type:"13",
        example:"012345678941",
        regex:"^(?:[0-9]{2}|[0-9]{5}|[0-9]{7}|[0-9]{12})$"
    },
    {
        slug : "msi-plessey",
        char_set: "0-9",
        length: "Variable (unlimited)",
        category: "Warehousing, Library, Most popular",
        data_d_type:"1d",
        data_sym_type:"47",
        example:"1234567890123",
        regex: "^[0-9]*$"   
    },
    {
        slug : "telepen",
        char_set: "0-9; x",
        length: "Variable (up to 60 digits)",
        category: "",
        data_d_type:"1d",
        data_sym_type:"87",
        example:"0123456789",
        regex: "^[0-9]{1,60}$"
	}

]

export const twoD_barcodes = [
    {
        slug : "qr-code",
        char_set: "ASCII",
        length: "Variable (7089)",
        category: "Advertising, Most popular",
        data_d_type:"2d",
        data_sym_type:"58",
        example:"barkoder.com",
        regex: "^[\x00-\x7F]*$"
    },
    {
        slug : "pdf417",
        char_set: "ASCII, 0-255, 0-9",
        length: "Variable (2710)",
        category: "Transport, Logistics, Warehousing, Government, Most Popular",
        data_d_type:"2d",
        data_sym_type:"55",
        example:"barkoder.com",
        regex: "^[\x00-\x7F]*$" 
    },
    {
        slug : "aztec",
        char_set: "Alphanumeric",
        length: "Variable (3823)",
        category: "Transport, Railway, Most popular",
        data_d_type:"2d",
        data_sym_type:"92",
        example:"barkoder.com",
         regex: "^[a-zA-Z0-9]+$"
    },
    {
        slug : "data-matrix",
        char_set: "ASCII, 1 - 255",
        length: "Variable (3116)",
        category: "Industry, Marketing, Post, Electronics, Medical, Most popular",
        data_d_type:"2d",
        data_sym_type:"71",
        example:"barkoder.com",
        regex: "^[\x00-\x7F]*$" 
    },
    {
        slug : "dotcode",
        char_set: "ASCII",
        length: "Variable (450)",
        category: "Industry, Electronics, Medical",
        data_d_type:"2d",
        data_sym_type:"115",
        example:"barkoder.com",
        regex: "^[\x00-\x7F]*$"
    },
]